<section>
  <h2> Company User roles </h2>

  <mat-card>
    <mat-card-content>
      @for (role of roles; track role) {
        <mat-checkbox
          [disabled]="disableOwnRoles"
          [checked]="hasRole(role.id)"
          (change)="onSelected($event.source.checked, role)"
          class="mr-3">
          {{role.name }}
        </mat-checkbox>
      }
    </mat-card-content>

  </mat-card>
</section>